import React, { lazy, Suspense } from 'react';
import { APCalculatorBase } from '../../../components/tools/APCalculatorBase';

const frqQuestions = [
  {
    name: "Long Free Response 1",
    maxScore: 10,
    weight: 0.125,
    description: "Chemical reactions and stoichiometry"
  },
  {
    name: "Long Free Response 2",
    maxScore: 10,
    weight: 0.125,
    description: "Thermodynamics and equilibrium"
  },
  {
    name: "Short Free Response 1",
    maxScore: 4,
    weight: 0.0625,
    description: "Atomic structure and periodicity"
  },
  {
    name: "Short Free Response 2",
    maxScore: 4,
    weight: 0.0625,
    description: "Kinetics and reaction mechanisms"
  },
  {
    name: "Short Free Response 3",
    maxScore: 4,
    weight: 0.0625,
    description: "Solutions and acid-base chemistry"
  }
];

const apChemConfig = {
  title: "AP Chemistry Score Calculator 2025 | AP Chem Score Calculator",
  description: "Calculate your AP Chemistry exam score instantly with our comprehensive calculator. Updated for 2025 AP Chem exam format with detailed scoring guidelines for multiple choice and free response sections.",
  keywords: [
    "ap chem score calculator",
    "AP Chem calculator",
    "AP Chemistry score calculator",
    "AP Chem score estimation",
    "AP Chemistry exam calculator",
    "2025 AP Chemistry scoring",
    "AP Chem score conversion",
    "AP Chemistry FRQ scoring"
  ],
  mcqTotal: 60,
  frqQuestions,
  mcqWeight: 0.5,
  frqWeight: 0.5,
  path: "/tools/ap-chem-score-calculator",
  examSpecificInfo: {
    fullName: "AP Chemistry",
    examFormat: "Multiple choice (60 questions, 90 minutes) and free response (7 questions, 105 minutes)",
    passingRate: "Approximately 54% of students score 3 or higher",
    collegeCredit: "Many colleges offer credit for scores of 3 or higher"
  }
};

const LoadingPlaceholder = () => (
  <div className="p-8 max-w-4xl mx-auto">
    <div className="animate-pulse">
      <div className="h-10 bg-gray-200 rounded w-3/4 mb-6"></div>
      <div className="h-6 bg-gray-200 rounded w-1/2 mb-4"></div>
      <div className="h-40 bg-gray-200 rounded mb-6"></div>
    </div>
  </div>
);

export function APChemCalculator() {
  return (
    <Suspense fallback={<LoadingPlaceholder />}>
      <APCalculatorBase config={apChemConfig} />
    </Suspense>
  );
}